import React from 'react';
import { Button, ButtonType } from 'syngenta-digital-cropwise-react-ui-kit';
import DeleteOutlinedIcon from 'assets/delete_outlined.svg?react';
import EditOutlinedIcon from 'assets/edit_outlined.svg?react';

import './styles.css';

const ACTION_BUTTON_SIZE = 18;

interface TableActionsProps {
  onEdit?: () => void;
  onDelete: () => void;
  showEdit?: boolean;
  editButtonLabel?: string;
  deleteButtonLabel?: string;
}

const TableActions: React.FC<TableActionsProps> = ({
  onEdit,
  onDelete,
  showEdit = true,
  editButtonLabel,
  deleteButtonLabel
}) => {
  return (
    <div
      className="table-actions flex items-center mr-6"
      style={{ justifyContent: 'flex-start', gap: '4px' }}
    >
      {showEdit && onEdit ? (
        <>
          <Button
            type={ButtonType.ghost}
            size="small"
            onClick={onEdit}
            icon={
              <EditOutlinedIcon
                data-testid="edit-icon"
                height={ACTION_BUTTON_SIZE}
                width={ACTION_BUTTON_SIZE}
              />
            }
            style={{
              padding: '3px',
              border: 'none'
            }}
            aria-label={editButtonLabel || 'Edit'}
          />
          <div
            className="text-sm font-normal leading-5 text-gray-400 w-2 h-5 flex items-center justify-center"
            aria-hidden="true"
          >
            |
          </div>
        </>
      ) : (
        <div style={{ width: ACTION_BUTTON_SIZE * 2 }} />
      )}

      <Button
        type={ButtonType.ghost}
        size="small"
        onClick={onDelete}
        icon={
          <DeleteOutlinedIcon
            data-testid="delete-icon"
            height={ACTION_BUTTON_SIZE}
            width={ACTION_BUTTON_SIZE}
          />
        }
        style={{
          padding: '3px',
          border: 'none'
        }}
        aria-label={deleteButtonLabel || 'Delete'}
      />
    </div>
  );
};

export default TableActions;
